
import { defineComponent, ref, computed } from 'vue';
import { useSpacesStore } from '../store/spacesStore';
import { IGroupData } from '@/types/interfaces';
import SpacesUserTransition from './SpacesUserTransition.vue';
import AppItemWrapper from '@/components/AppItemWrapper.vue';
import AppSkeletonContact from '@/components/skeletons/AppSkeletonContact.vue';
import SpacesGroup from '@/modules/spaces/components/SpacesGroup.vue';
import { NETWORK_CONTACT_TYPES } from '@/types/enums';

export default defineComponent({
  props: {
    skeleton: { type: Boolean, default: false },
  },
  components: {
    SpacesGroup,
    SpacesUserTransition,
    AppItemWrapper,
    AppSkeletonContact,
  },
  setup(props, { emit }) {
    const spacesStore = useSpacesStore();
    const isGroupInfo = ref(false);
    const showAll = ref(false);

    const myGroups = computed(() => {
      if (!showAll.value) {
        return spacesStore.myGroups.length <= 10 ? spacesStore.myGroups : spacesStore.myGroups.slice(0, 10);
      }
      return spacesStore.myGroups;
    });

    function openGroupInfo(group: IGroupData) {
      emit('open-group', group);
    }

    return {
      spacesStore,
      isGroupInfo,
      myGroups,
      showAll,
      openGroupInfo,
      NETWORK_CONTACT_TYPES,
    };
  },
});
